import React from 'react';
import {
  Box,
  Typography,
  Alert,
  Button,
  Paper,
  Stack,
  useTheme,
  alpha,
} from '@mui/material';
import {
  Info,
  CloudDownload,
  MailOutline,
} from '@mui/icons-material';

export function ExportData() {
  const theme = useTheme();

  return (
    <Box sx={{ maxWidth: '700px' }}>
      <Typography variant="h4" fontWeight={800} gutterBottom>
        Data Export Request
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Your privacy and data portability are important to us. Request a full archive of your activity and data.
      </Typography>

      <Alert 
        severity="info"
        icon={<Info fontSize="large" />}
        sx={{ 
          mb: 4, 
          borderRadius: '16px',
          bgcolor: alpha(theme.palette.info.main, 0.05),
          border: '1px solid',
          borderColor: alpha(theme.palette.info.main, 0.2),
          '& .MuiAlert-message': { fontSize: '1rem', fontWeight: 500, lineHeight: 1.6 }
        }}
      >
        You may download a copy of all data you have created on this platform. Click the button below to start a new request. 
        An email will be sent to you to verify the request. Once verified, the site administration will review your request, 
        and if approved, a secure archive will be generated and emailed to you.
      </Alert>

      <Stack direction="row" spacing={3} alignItems="center" sx={{ p: 1 }}>
        <Button 
          variant="contained" 
          size="large"
          startIcon={<CloudDownload />}
          sx={{ 
            px: 6, 
            py: 1.5, 
            borderRadius: '50px', 
            fontWeight: 800,
            boxShadow: '0 8px 25px rgba(212, 175, 55, 0.2)'
          }}
        >
          Request Data Export
        </Button>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
          <MailOutline fontSize="small" />
          <Typography variant="caption" fontWeight={600}>Verification email will be sent</Typography>
        </Box>
      </Stack>
    </Box>
  );
}
